/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const CheckboxWrap = styled.div`
  ${({ isBorder }) =>
    isBorder &&
    css`
      border-right: 1px solid ${Palette.PrimaryGray._200};
    `}

  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 100%;
`;

export const Box = styled.div`
  background-color: ${Palette.PrimaryGray._000};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const GroupingBox = styled.div`
  position: relative;
`;

export const ArrowIcon = styled.div`
  display: flex;
  padding: 8px;
  cursor: pointer;
  fill: ${Palette.PrimaryGray._500};
  transition: transform 0.2s linear;

  ${({ direction }) => {
    if (direction === 'ascending')
      return css`
        fill: ${Palette.Primary._500};
        transform: rotate(180deg);
      `;
    if (direction === 'descending')
      return css`
        fill: ${Palette.Primary._500};
      `;
  }}

  svg {
    width: 8px;
  }
`;

export const Text = styled.div`
  color: ${Palette.PrimaryGray._500};
  margin: 0 8px 0 16px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const DisabledText = styled.p`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const ChooseRequest = styled(DisabledText)`
  width: 130px;
  border-radius: 4px;
  border: 1px solid ${Palette.Primary._200};
  background: ${Palette.Primary._000};
  padding: 10px 16px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  svg {
    margin-left: auto;
    transform: rotate(0deg);
    transition: transform 200ms linear;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      svg {
        fill: ${Palette.Primary._500};
        transform: rotate(180deg);
        transition: transform 200ms linear;
      }
    `};
`;
